import Vue from 'vue';
import Ionic from '@ionic/vue';
//import { library } from '@fortawesome/fontawesome-svg-core';
//import { faClock, faHotel, faPlaneDeparture, faSuitcase, faSignOutAlt, faUserCircle, faTrash } from '@fortawesome/free-solid-svg-icons';
/*import { faClock } from '@fortawesome/free-solid-svg-icons/faClock';
import { faHotel } from '@fortawesome/free-solid-svg-icons/faHotel';
import { faPlaneDeparture } from '@fortawesome/free-solid-svg-icons/faPlaneDeparture';
import { faSuitcase } from '@fortawesome/free-solid-svg-icons/faSuitcase';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons/faSignOutAlt';
import { faUserCircle } from '@fortawesome/free-solid-svg-icons/faUserCircle';
import { faTrash } from '@fortawesome/free-solid-svg-icons/faTrash';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';*/
//import * as AmplifyModules from 'aws-amplify';
import Amplify, { Logger, I18n } from '@aws-amplify/core';
import Auth, { AuthClass } from '@aws-amplify/auth';
import { AmplifyPlugin, AmplifyEventBus } from 'aws-amplify-vue';
import awsconfig from './aws-exports';
import App from './App.vue';
import router from './router';
import store from './store';
import VueAnalytics from 'vue-analytics';
import { addIcons } from 'ionicons';
import i18n from './i18n'
import { addCircle, airplane, arrowDown, arrowForward, arrowRoundForward, arrowUp, bed, boat, bus,
  calendar, checkmarkCircle, closeCircleOutline, compass, contact, cube, gift, helpCircleOutline, lock, logoFacebook, logoGoogle,
  logOut, mail, notifications, radioButtonOff, time, train, trash } from 'ionicons/icons';
/*import { addCircle } from 'ionicons/icons/addCircle';
import { airplane } from 'ionicons/icons/airplane';*/

addIcons({
  "ios-add-circle": addCircle.ios,
  "md-add-circle": addCircle.md,
  "ios-airplane": airplane.ios,
  "md-airplane": airplane.md,
  "ios-arrow-down": arrowDown.ios,
  "md-arrow-down": arrowDown.md,
  "ios-arrow-forward": arrowForward.ios,
  "md-arrow-forward": arrowForward.md,
  "ios-arrow-round-forward": arrowRoundForward.ios,
  "md-arrow-round-forward": arrowRoundForward.md,
  "ios-arrow-up": arrowUp.ios,
  "md-arrow-up": arrowUp.md,
  "ios-bed": bed.ios,
  "md-bed": bed.md,
  "ios-boat": boat.ios,
  "md-boat": boat.md,
  "ios-bus": bus.ios,
  "md-bus": bus.md,
  "ios-calendar": calendar.ios,
  "md-calendar": calendar.md,
  "ios-checkmark-circle": checkmarkCircle.ios,
  "md-checkmark-circle": checkmarkCircle.md,
  "ios-close-circle-outline": closeCircleOutline.ios,
  "md-close-circle-outline": closeCircleOutline.md,
  "ios-compass": compass.ios,
  "md-compass": compass.md,
  "ios-contact": contact.ios,
  "md-contact": contact.md,
  "ios-cube": cube.ios,
  "md-cube": cube.md,
  "ios-gift": gift.ios,
  "md-gift": gift.md,
  "ios-help-circle-outline": helpCircleOutline.ios,
  "md-help-circle-outline": helpCircleOutline.md,
  "ios-lock": lock.ios,
  "md-lock": lock.md,
  "ios-log-out": logOut.ios,
  "md-log-out": logOut.md,
  "logo-facebook": logoFacebook,
  "logo-google": logoGoogle,
  "ios-mail": mail.ios,
  "md-mail": mail.md,
  "ios-notifications": notifications.ios,
  "md-notifications": notifications.md,
  "ios-radio-button-off": radioButtonOff.ios,
  "md-radio-button-off": radioButtonOff.md,
  "ios-time": time.ios,
  "md-time": time.md,
  "ios-train": train.ios,
  "md-train": train.md,
  "ios-trash": trash.ios,
  "md-trash": trash.md,
});

import '@ionic/core/css/core.css';
import '@ionic/core/css/ionic.bundle.css';
import '@/registerServiceWorker'

/*library.add(faClock);
library.add(faTrash);
library.add(faHotel);
library.add(faPlaneDeparture);
library.add(faSuitcase);
library.add(faSignOutAlt);
library.add(faUserCircle);

Vue.component('font-awesome-icon', FontAwesomeIcon);*/
Amplify.configure(awsconfig);

Vue.use(Ionic);
//Vue.use(AmplifyPlugin, AmplifyModules);
Vue.use(AmplifyPlugin, { AuthClass, Auth, Logger, I18n });

Vue.use(VueAnalytics, {
  id: 'UA-148429051-1',
  router
});

console.log('VUE LOG LEVEL', process.env.VUE_APP_LOG_LEVEL);

Storage.prototype.setObject = function(key, value) {
  this.setItem(key, JSON.stringify(value));
}

Storage.prototype.getObject = function(key) {
  var value = this.getItem(key);
  return value && JSON.parse(value);
}

Vue.prototype.$logger = new Logger('nimtu', process.env.VUE_APP_LOG_LEVEL);
Vue.prototype.$AmplifyEventBus = AmplifyEventBus;
Vue.prototype.$store = store;

Vue.config.productionTip = false;

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app');
